<style>
  .el-collapse-item__header {
      padding-left: 15px;
  }
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
} 
  .circle-closesty {
      position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  .v-modal {
    z-index: 100 !important;
  }
</style>
<template>
  <div class="content"> 
    <div class=" back-color-fff p16 pt2">
    <div class="content-text mb15">
              <img width="25" class="fl" src="../../assets/images/remind1.png">
              <p>在缴明细一般每月26号左右生成，遇节假日及政策调整，可能会有延迟</p>
      </div>  
      <el-table :data="tableData" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
            <!-- {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}} -->
          </template>
        </el-table-column>
        <el-table-column prop="accessTime" label="月份" header-align="center" align="center"></el-table-column>
        <el-table-column prop="organisationNames" label="状态" header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.status | insuranceStatus}}</template>
        </el-table-column>
        <!-- <el-table-column prop="organisationNames" label="发布时间" header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.organisationNames | roleNames}}</template>
        </el-table-column> -->  
        <el-table-column label="操作" header-align="center" align="center" fixed='right'>
          <template slot-scope="scope">
            <a class="txt-color" @click="toLink()">详情</a> 
          </template>
        </el-table-column>
      </el-table> 
    </div>
    <!-- <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>    -->
  </div>
</template>

<script>  
export default {
  data() {
    return {  
        tableData:[],  
        tableLoading:false
    };
  },
  created() {
    // 列表
    this.getData();  
    // this.getCurrentManageStaff();
  }, 
  methods: { 
    getData(flg) {
      let self = this;
      // self.page.performanceGuid = self.$router.history.current.query.guid;
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msUserRemunerationService}/sb51/get-insurancedetail-detail?insuranceCategory=1`).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.result; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    toLink(){
             this.$router.push({path: "/insuredManagementDetails", query:{   productGuid:this.$route.query.productGuid,userGuid:'ca3b7bc2746e43ebab6e468b6fc56f2e'}})
    }
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
     height: 40px; 
     line-height: 40px; 
}
.el-range-editor.el-input__inner { 
     padding: 0px; 
}
/deep/ .el-checkbox__label {
    display: none;
}
.attach-sty {
    width: 170px;
    float: left; 
    margin-top: 15px;
    text-align: center;
}
.checkbox-img-sty {
    border: 1px solid #DCDFE6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
}
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>